import { Inject, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as Rx from 'rxjs';
import Swal from 'sweetalert2';
import { CommentAPIService } from '../comment.service';
import { UserInfoService } from '../../user/user-info.service';

@Component({
	templateUrl: './comment-join.dialog.html'
})
export class CommentJoinDialog {
	objectId: string = "";
	objectName: string = "";
	join: boolean = false;
	isAnonymous: boolean = true;

	constructor(
		private dialogRef: MatDialogRef<CommentJoinDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private commentAPI: CommentAPIService,
		public userInfo: UserInfoService
	) {
		this.isAnonymous = this.userInfo.isAnonymous();
		this.objectId = data.objectId;
		this.objectName = data.objectName;
	}

	toggleStatus(forJoin: boolean): void {
		this.commentAPI.updateCommentPerson(this.objectId, (forJoin ? "add" : "delete")).subscribe(
			response => {
				this.dialogRef.close(forJoin);
			},
			err => {
				console.log(err);
				Swal.fire("Error", "Fail to save selection", "error")
					.then(() => {
						this.close(null);
					});
			}
		);
	}

	close(e:any): void {
		this.dialogRef.close(null);
	}

	ngOnInit(): void {
		if (this.isAnonymous) {
			this.close(null);
		}
	}
}

@Component({
	selector: 'app-comment-icon',
	templateUrl: './comment-icon.component.html',
	styleUrls: ["./comment-icon.scss"]
})
export class CommentIconComponent implements OnInit, OnDestroy {
	@Input() objectName: string = "";
	@Input() objectId: string = "";
	@Input() tipPos: "left" | "top" | "bottom" | "" = ""; // display tooltip at left/right/top/bottom default is empty (not display)

	constructor(
		private commentAPI: CommentAPIService,
		private router: Router,
		private userInfo: UserInfoService
	) {
		this.isAnonymous = this.userInfo.isAnonymous();
	}

	displayIcon: boolean = false;
	loading: boolean = false;
	toolTip: string = ""
	private isAnonymous: boolean = true;
	isJoin: boolean = false;
	

	private updateIcon(): void {
		this.loading = true;
		this.commentAPI.checkCommentPersonExist(this.objectId).subscribe(
			(response) => {
				this.isJoin = response;
				this.loading = false;
			},
			(err) => {
				console.log(err);
				this.loading = false;
			}
		);
	}

	goComment(e: any): void {
		this.router.navigateByUrl("/Comment/" + this.objectId);
	}

	private commentGroupWatcher: Rx.Subscription = null;

	private watchCommentGroup(): void {
		this.commentGroupWatcher = this.commentAPI.CommentGroupchanged.subscribe(
			(success:any) => {
				this.updateIcon();
			},
			(err: any) => {
				console.log(err);
				this.updateIcon();
			}
		);
	}

	ngOnDestroy() {
		if (this.commentGroupWatcher != null) {
			this.commentGroupWatcher.unsubscribe();
		}
	}

	ngOnInit(): void {
		this.toolTip = this.tipPos === "" ? "" : "Comments";
		if (!this.isAnonymous && this.objectId != "") {
			this.displayIcon = true;
			this.watchCommentGroup();
		}
	}
}
